import { states } from "utils/camp-parameters"

export const getCamperInfo = camper => {
  let gender = camper.attributes.gender
  let age = camper.attributes.age
  let grade = camper.attributes.grade

  let gradeString = grade
  switch (grade) {
    case 1:
      gradeString += "st grade"
      break
    case 2:
      gradeString += "nd grade"
      break
    case 3:
      gradeString += "rd grade"
      break
    default:
      gradeString += "th grade"
      break
  }

  return gender + ", " + age + " (" + gradeString + ")"
}

export const formatDateRange = (start, end) =>
  start.split("T")[0] + " to " + end.split("T")[0]

export const getAbbrFromState = st => {
  let state = states.find(state => state.name === st)
  return state ? state.abbr : ""
}

export const getGoogleMapsAddress = campAttributes =>
  campAttributes["camp-address"] +
  " " +
  (campAttributes["camp-address-2"] !== ""
    ? campAttributes["camp-address-2"] + " "
    : "") +
  campAttributes["camp-city"] +
  " " +
  getAbbrFromState(campAttributes["camp-state"]) +
  " " +
  campAttributes["camp-zip"] +
  " " +
  campAttributes["camp-country"]



// WEBPACK FOOTER //
// ./src/utils/camper-utils.js